import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { Contacts } from '../../components/Contacts';
import { IAgentCardPhone } from '../../types/agentCard';
import { PhoneContainer } from '../PhoneContainer';
import { selectCompany } from 'shared/slices';

export const ContactsContainer = () => {
  const { ctPhoneNumber, skype, website, regionsNames, phones } = useSelector(selectCompany, shallowEqual);

  const phonesNode = React.useMemo(() => {
    if (ctPhoneNumber) {
      return <PhoneContainer phone={ctPhoneNumber} />;
    }

    if (phones.length) {
      return phones.map((phone: IAgentCardPhone) => (
        <PhoneContainer key={phone.number} phone={`${phone.countryCode}${phone.number}`} />
      ));
    }

    return null;
  }, [ctPhoneNumber, phones]);

  return <Contacts phonesNode={phonesNode} skype={skype} website={website} regionsNames={regionsNames.join(', ')} />;
};
